import { Component, OnInit, Input } from '@angular/core';


import { GooglePieChartService } from '../GooglePieChartService';
import { PieChartConfig } from '../PieChartConfig';

declare var google: any;

@Component({
  selector: 'pie-chart',
  templateUrl: './pie-chart-component.component.html',
  styleUrls: ['./pie-chart-component.component.css']
})
export class PieChartComponentComponent implements OnInit {

 
  @Input() data: any[];
  @Input() config: PieChartConfig;
  @Input() elementId: string;

  constructor(private _pieChartService: GooglePieChartService) {}

  ngOnInit(): void {
      this._pieChartService.BuildPieChart(this.elementId, this.data, this.config); 
  }

}
